import React, { JSX, useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";

import { PageBaseWrapper } from "./PageBaseWrapper";
import { DashboardRoutes } from "./DashboardRoutes";
import { useUser } from "../../contexts/UserContext";
import { SpinnyThingy } from "../Misc/SpinnyThingy";
import { LogInManager } from "../../containers/LogInManager";
import { SettingsContextProvider } from "../../contexts/SettingsContextProvider";
import { UserInfoContextProvider } from "../../contexts/UserInfoContext";

export function Main(): React.ReactElement {

  const [renderPage, setRenderPage] = useState<JSX.Element | null>();
  const userContext = useUser();

  useEffect(() => {
    if (userContext.user === null && userContext.fetchingUser) {
      setRenderPage(
        <div className="spinny-thingy-margin">
          <SpinnyThingy />
        </div>,
      );
    } else if (userContext.user === null) {
      setRenderPage(
        <>
          <Route path="" render={() => <LogInManager />} />
          <Route path="" render={() => <Redirect to="" />} />
        </>,
      );
    } else {
      setRenderPage(
        <UserInfoContextProvider user={userContext.user}>
          <SettingsContextProvider>
            <PageBaseWrapper>
              <DashboardRoutes />
            </PageBaseWrapper>
          </SettingsContextProvider>
        </UserInfoContextProvider>,
      );
    }
  }, [userContext.user, userContext.fetchingUser]);

  return <main>{renderPage}</main>;
}
